import gql from 'graphql-tag';
import {
  ACCOUNT_RESULT_FRAGEMENT,
  CREATE_ACCOUNT_SUCCESS_FRAGMENT,
  SIGNUP_PROGRESSION_FRAGMENT,
  LOGIN_FRAGMENT,
  ACCOUNT_OFFER_FRAGMENT,
} from './fragment';
const LOGIN = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      ...loginInfo
    }
  }
  ${LOGIN_FRAGMENT}
`;
const CREATE_ACCOUNT = gql`
  mutation CreateAccount($email: String!, $password: String!, $phone: String!) {
    createAccount(email: $email, password: $password, phone: $phone) {
      ...createAccountSuccessInfos
    }
  }
  ${CREATE_ACCOUNT_SUCCESS_FRAGMENT}
`;

const CREATE_SHAREHOLDER_ACCOUNT = gql`
  mutation CreateShareholderAccount(
    $idAccount: ID
    $email: String!
    $phone: String!
  ) {
    createShareholderAccount(
      idAccount: $idAccount
      email: $email
      phone: $phone
    ) {
      id
      email
      phone
    }
  }
`;

const CONFIRM_ACCOUNT = gql`
  mutation ConfirmAccount($code: String!) {
    confirmAccount(code: $code) {
      accessToken
    }
  }
`;
const RESEND_CODE = gql`
  mutation ResendCode($email: String!) {
    resendCode(email: $email) {
      ...AccountResult
    }
  }
  ${ACCOUNT_RESULT_FRAGEMENT}
`;

const SIGNUP_PROGRESSION = gql`
  mutation SignupProgression($step: Int!) {
    signupProgression(step: $step)
  }
`;

const SELECT_OFFER_AND_COMPANY_TYPE = gql`
  mutation SelectOfferAndCompanyType(
    $offerId: ID!
    $existingCompany: Boolean!
    $packageSelected: Int
  ) {
    selectOfferAndCompanyType(
      offerId: $offerId
      existingCompany: $existingCompany
      packageSelected: $packageSelected
    )
  }
`;

const REQUEST_EMAIL_VALID = gql`
  mutation RequestEmailValid($email: String!) {
    updateEmail(email: $email) {
      id
    }
  }
`;

const SHAREHOLDERS_EMAIL_VALID = gql`
  mutation ShareholdersEmailValid($inputs: [EmailCheckInputs]) {
    checkShareholderEmail(inputs: $inputs)
  }
`;
export {
  CREATE_ACCOUNT,
  CREATE_SHAREHOLDER_ACCOUNT,
  CONFIRM_ACCOUNT,
  RESEND_CODE,
  SELECT_OFFER_AND_COMPANY_TYPE,
  SIGNUP_PROGRESSION,
  LOGIN,
  REQUEST_EMAIL_VALID,
  SHAREHOLDERS_EMAIL_VALID,
};
